import {BiError, BiErrorCircle} from "react-icons/bi";

const Alert = ({type, title, subtext}) => {

    if (type === 'error') {
        return (<>
            <div
                className="container mx-auto shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] mt-8 border-t-2 border-red-500 rounded-b text-red-900 px-4 py-3"
                role="alert">
                <div className="flex">
                    <div className="my-auto">
                        <BiErrorCircle className={"fill-current h-6 w-6 text-red-500 mr-4"}></BiErrorCircle>
                    </div>
                    <div>
                        <p className="font-bold">{title}</p>
                        <p className="text-sm">{subtext}</p>
                    </div>
                </div>
            </div>
        </>)
    }
    if (type === 'warning') {
        return (<>
            <div
                className="container mx-auto shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] mt-8 border-t-2 border-orange-500 rounded-b text-orange-900 px-4 py-3"
                role="alert">
                <div className="flex">
                    <div className="my-auto">
                        <BiError className={"fill-current h-6 w-6 text-orange-500 mr-4"}></BiError>
                    </div>
                    <div>
                        <p className="font-bold">{title}</p>
                        <p className="text-sm">{subtext}</p>
                    </div>
                </div>
            </div>
        </>)
    }

    return (<></>)
}

export default Alert;